import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withCtx as _withCtx, resolveDirective as _resolveDirective, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "column q-gutter-sm q-my-sm" }

import { computed, onBeforeMount, onMounted, ref } from 'vue'
import { useFormatDate } from '../composables/formatDate'
import FormHeader from './FormHeader.vue'
import TypeAheadUsers from './TypeAheadUsers.vue'
import { Message, sanitizeMessage } from '../store/useMessages'
import { useAPIURLs } from '../composables/useAPIURLs'
import { useI18n } from 'vue-i18n'

type FormProps = {
  /**Locks the subject and user */
  reply: boolean
  sent?: boolean
  message: undefined | { message: Message; sent: boolean }
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FormMessage',
  props: {
    reply: { type: Boolean, default: false },
    sent: { type: Boolean },
    message: {}
  },
  emits: ["send"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const { t } = useI18n({ useScope: 'global' })
const form = (label: string) => t(`form.${label}`)
const formLabel = (label: string) => t(`form.messages.${label}`)

const user = ref()
const userRef = ref()
const subject = ref()
const subjectRef = ref()
const body = ref()
const bodyRef = ref()

onBeforeMount(() => {
  close.value = false
  if (props.reply && props.message) {
    subject.value = props.message.message.subject.startsWith('Re: ')
      ? props.message?.message.subject
      : `Re: ${props.message?.message.subject}`
    body.value = renderBody(props.message?.message)
  }
})
onMounted(() => {
  if (props.reply && props.message) {
    //focus at start of input
    const el = bodyRef.value.getNativeElement()
    el.setSelectionRange(0, 0)
  }
})
const renderDate = computed(() => {
  const messageDate = useFormatDate(props.message?.message.date)
  return `${messageDate.weekday()}, ${messageDate.month()} ${messageDate.day()}, ${messageDate.time()}`
})

// const toReg = new RegExp(`<${props.message?.message.to.username}>`)
// const fromReg = new RegExp(`<${props.message?.message.from.username}>`)

const splitLines = (data: string) => {
  const splitData = data.replaceAll('\n', '')

  return `>${
    sanitizeMessage(splitData)
      // render < > tags for usernames etc
      .replaceAll(
        `&lt;${props.message?.message.to.username}&gt;`,
        `<${props.message?.message.to.username}>`
      )
      .replaceAll(
        `&lt;${props.message?.message.from.username}&gt;`,
        `<${props.message?.message.from.username}>`
      )
    // .replaceAll('&gt;', '\n>')
    // .replaceAll('&gt;', '>')
    // .replaceAll('&lt;', '<')
    //
  }
    `
}
const renderBody = (data: Message) => {
  return `\n\n>On ${renderDate.value}, ${data.from.name} <${
    data.from.username
  }>  wrote:\n>\n${splitLines(data.body)}`
}

const close = ref(false)
const validate = () => {
  let userValidate = true
  let subjectValidate = true
  let bodyValidate = true
  if (userRef.value) {
    userValidate = userRef.value.validate()
  }
  if (subjectRef.value) {
    subjectValidate = subjectRef.value.validate()
  }
  if (bodyRef.value) {
    bodyValidate = bodyRef.value.validate()
  }
  return userValidate && subjectValidate && bodyValidate
}
const cleanMessage = (body: string) => {
  return sanitizeMessage(
    body
      // .replaceAll('>', '&gt;')
      // .replaceAll('<', '&lt;')
      .replaceAll(
        `<${props.message?.message.to.username}>`,
        `&lt;${props.message?.message.to.username}&gt;`
      )
      .replaceAll(
        `<${props.message?.message.from.username}>`,
        `&lt;${props.message?.message.from.username}&gt;`
      )
      .replaceAll(/(?:\r\n|\r|\n)/g, '<p>')
  )
}
const sendMessage = () => {
  if (validate()) {
    emit('send', {
      to: user.value,
      subject: subject.value,
      body: cleanMessage(body.value),
    })
    close.value = true
  }
}
const { API } = useAPIURLs()

return (_ctx: any,_cache: any) => {
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(FormHeader, _mergeProps({
      "header-text": formLabel('reply')
    }, user.value), null, 16, ["header-text"]),
    _createVNode(_component_q_card_section, { class: "q-pt-none" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_1, [
          _createVNode(TypeAheadUsers, {
            ref_key: "userRef",
            ref: userRef,
            "hide-bottom-space": "",
            modelValue: user.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((user).value = $event)),
            label: form('to'),
            route: _unref(API).getMessagingUsers,
            autofocus: !_ctx.reply,
            readonly: _ctx.reply,
            rules: [ (val) => (typeof val !== "undefined" && val !== null) || form("requiredGeneric"),],
            username: _ctx.sent ? _ctx.message?.message.to : _ctx.message?.message.from
          }, null, 8, ["modelValue", "label", "route", "autofocus", "readonly", "rules", "username"]),
          _createVNode(_component_q_input, {
            ref_key: "subjectRef",
            ref: subjectRef,
            "hide-bottom-space": "",
            readonly: _ctx.reply,
            filled: "",
            color: "accent",
            modelValue: subject.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((subject).value = $event)),
            rules: [ (val) => (typeof val !== "undefined" && val !== null) || form("requiredGeneric"),],
            type: "text",
            label: formLabel('subject')
          }, null, 8, ["readonly", "modelValue", "rules", "label"]),
          _createVNode(_component_q_input, {
            autofocus: _ctx.reply,
            "data-body-input": "",
            ref_key: "bodyRef",
            ref: bodyRef,
            "hide-bottom-space": "",
            filled: "",
            color: "accent",
            modelValue: body.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((body).value = $event)),
            type: "textarea",
            rules: [ (val) => (typeof val !== "undefined" && val !== null) || form("requiredGeneric"),],
            label: formLabel('message')
          }, null, 8, ["autofocus", "modelValue", "rules", "label"])
        ], 512), [
          [_vShow, userRef.value]
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_q_card_actions, {
      align: "right",
      class: "text-primary"
    }, {
      default: _withCtx(() => [
        _withDirectives(_createVNode(_component_q_btn, {
          "no-caps": "",
          flat: "",
          label: _unref(t)('form.close')
        }, null, 8, ["label"]), [
          [_directive_close_popup]
        ]),
        _withDirectives(_createVNode(_component_q_btn, {
          "no-caps": "",
          rounded: "",
          onClick: sendMessage,
          color: "primary",
          label: form('sendMessage')
        }, null, 8, ["label"]), [
          [_directive_close_popup, close.value]
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})